import { render, staticRenderFns } from "./PermissionsGoalsForm.vue?vue&type=template&id=0dec5562&scoped=true&"
import script from "./PermissionsGoalsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsGoalsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec5562",
  null
  
)

export default component.exports